import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import logo from './../assets/images/brand/assista_horizontal-punchout.svg';

class Navbar extends Component {
    render() {
        return (
            <header className="masthead border-light border-bottom bg-white mb-auto text-center navbar navbar-light navbar-expand-md">
                <div className="container-fluid masthead-container">
                    <Link className="h3 navbar-brand masthead-brand mx-lg-auto mb-lg-auto" to={"/index"}>
                        <img className="img-fluid" src={logo} alt="Assist@" width="224" />
                        <h1 className="sr-only visually-hidden">Assist@: Menu</h1>
                    </Link>
                    <button className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <nav className={"collapse navbar-collapse"} id="navbar-collapse">
                        <h1 className="sr-only visually-hidden">Menu: navigation</h1>
                        <ul className="nav navbar-nav masthead-nav ml-auto">
                            <li className="nav-item">
                                <Link className="nav-link" to="#">Accueil</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link" to="#">Offres & Tarifs</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="btn btn-primary" to="/auth/signin">Se connecter</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
        )
    }
}

const mapStateToProps = (state) => ({
    example: state.example,
  });
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);